import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  formattedDate,
  getCurrentDateTime1,
} from "../../../../Common/helper/helpar";

export const NoOfBinsExport = ({ data = [] }) => {
  /* ================= GET FILTERS ================= */

  const storedFilters = localStorage.getItem("noOfBinsGvpFilters");
  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : null;
  const currentDateTime = getCurrentDateTime1();

  /* ================= DATE FORMAT ================= */

  const formatAsOnDate = (dateString) => {
    if (!dateString) return "-";

    const d = new Date(dateString);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

  const formatGeneratedOn = () => {
    const now = new Date();
    return `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}, ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
  };

  const generatedOn = formatGeneratedOn();

  const fromDate = parsedFilters?.StartDate
    ? formattedDate(parsedFilters.StartDate)
    : "-";

  const toDate = parsedFilters?.EndDate
    ? formattedDate(parsedFilters.EndDate)
    : "-";

  /* ================= TOTAL ================= */

  const totals = data.reduce(
    (acc, row) => {
      acc.totalBins += Number(row.totalBins || 0);
      acc.totalAttended += Number(row.attendedBins || 0);
      acc.cleared += Number(row.pointsCleared || 0);
      acc.notCleared += Number(row.notCleared || 0);
      return acc;
    },
    {
      totalBins: 0,
      totalAttended: 0,
      cleared: 0,
      notCleared: 0,
    },
  );

  const clearedPercent =
    totals.totalBins > 0
      ? ((totals.cleared / totals.totalBins) * 100).toFixed(2)
      : "0.00";

  const notClearedPercent =
    totals.totalBins > 0
      ? ((totals.notCleared / totals.totalBins) * 100).toFixed(2)
      : "0.00";

  /* ================= EXCEL DOWNLOAD ================= */

  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("No Of Bins Report");

    /* ===== ROW 1 ===== */
    sheet.addRow([
      `No of Bins/GVPs Attended Daily Report Generated on : ${generatedOn}`,
    ]);
    sheet.mergeCells("A1:J1");

    sheet.getCell("A1").font = { bold: true, size: 12 };
    sheet.getCell("A1").alignment = { horizontal: "center" };

    /* ===== ROW 2 ===== */
    sheet.addRow([
      `No of Bins/GVPs Attended Daily Report as on (${fromDate} to ${toDate})`,
    ]);
    sheet.mergeCells("A2:J2");

    sheet.getCell("A2").font = { bold: true };
    sheet.getCell("A2").alignment = { horizontal: "center" };

    sheet.addRow([]);

    /* ===== HEADER ===== */
    const header = sheet.addRow([
      "S.No",
      "Date",
      // "Points From Masters",
      "Total Bins",
      "Attended Bins",
      // "Points Cleared",
      " Performance Acheived",
      // "Not Cleared",
      // "Not Cleared %",
      "Remarks",
    ]);

    header.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0066CC" }, // 🔵 Same Blue as PDF
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    /* ===== DATA ===== */
    data.forEach((row, i) => {
      sheet.addRow([
        i + 1,
        row.date || "-",
        // row.pointsFromMasters || 0,
        row.totalBins || 0,
        row.attendedBins || 0,
        // row.pointsCleared || 0,
        row.clearedPercentage || "0.00",
        // row.notCleared || 0,
        // row.notClearedPercentage || "0.00",
        row.remarks || "Not Started",
      ]);
    });

    /* ===== TOTAL ROW ===== */
    const totalRow = sheet.addRow([
      "",
      "Total",
      // "",
      totals.totalBins,
      totals.totalAttended,
      "",
      // totals.cleared,
      // `${clearedPercent}%`,
      // totals.notCleared,
      // `${notClearedPercent}%`,
      "",
    ]);

    totalRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0066CC" }, // 🔵 Same Blue as PDF
      };
      cell.alignment = { horizontal: "center" };
    });

    /* ===== COLUMN WIDTH ===== */
    sheet.columns = [
      { width: 8 },
      { width: 14 },
      { width: 22 },
      { width: 18 },
      { width: 18 },
      { width: 15 },
      { width: 12 },
      { width: 15 },
      { width: 15 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "No of Bins/GVPs Attended Daily Report.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  /* ================= PDF DOWNLOAD ================= */

  const downloadPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    const headerText = `No of Bins/GVPs Attended Daily Report as on (${fromDate} to ${toDate})`;
    const topHeaderText = `No of Bins/GVPs Attended Daily Report is generated on (${currentDateTime})`;
    doc.setFontSize(10);
    const styledText = (text, x, y, size, options = {}) => {
      const originalSize = doc.getFontSize();
      doc.setFontSize(size);
      doc.text(text, x, y, options);
      doc.setFontSize(originalSize); // Reverts back automatically
    };

    const columns = [
      "S.No",
      "Date",
      // "Points From Masters",
      "Total Bins",
      "Attended Bins",
      // "Points Cleared",
      " Performance Acheived",
      // "Not Cleared",
      // "Not Cleared %",
      "Remarks",
    ];

    const rows = data.map((row, i) => [
      i + 1,
      row.date || "-",
      // row.pointsFromMasters || 0,
      row.totalBins || 0,
      row.attendedBins || 0,
      // row.pointsCleared || 0,
      row.clearedPercentage || "0.00",
      // row.notCleared || 0,
      // row.notClearedPercentage || "0.00",
      row.remarks || "Not Started",
    ]);

    rows.push([
      "",
      "Total",
      // "",
      totals.totalBins,
      totals.totalAttended,
      "",
      // totals.cleared,
      // `${clearedPercent}%`,
      // totals.notCleared,
      // `${notClearedPercent}%`,
      "",
    ]);
    const pageWidth = doc.internal.pageSize.width;
    const titleX = pageWidth / 2;
    const dateX = pageWidth / 2;
    // doc.text(downloadDateTime, dateX, 15, { align: "center" });
    styledText(topHeaderText, titleX, 15, 12, { align: "center" });
    styledText(headerText, titleX, 24, 14, { align: "center" });

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 30,
      styles: { fontSize: 9, halign: "center" },
      headStyles: {
        fillColor: [0, 102, 204], // Pink header same as Excel (#F6B1B1)
        textColor: 255,
        fontStyle: "bold",
      },
      didParseCell: function (data) {
        if (data.row.index === rows.length - 1) {
          // Total row styling
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [0, 102, 204]; // Pink background
          data.cell.styles.textColor = 255; // White text
        }
      },
    });

    doc.save("No of Bins/GVPs Attended Daily Report.pdf");
  };

  /* ================= UI ================= */

  return (
    <>
      <button className="btn btn-excel me-2" onClick={downloadPDF}>
        <i className="fa-solid fa-file-pdf me-1"></i> PDF
      </button>

      <button className="btn btn-excel" onClick={downloadExcel}>
        <i className="fa-solid fa-file-excel me-1"></i> Excel
      </button>
    </>
  );
};
